import { Link } from "react-router-dom";
import { communityPosts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function TickerBar() {
  const items = communityPosts.slice(0, 6);

  return (
    <section className="w-full bg-primary-500 text-background-50 overflow-hidden">
      <div className="flex items-center">
        <span className="shrink-0 flex items-center gap-2 h-11 px-4 md:px-6 bg-foreground-950 text-background-50 text-xs md:text-sm font-medium">
          <i className="ri-flashlight-fill"></i>
          此刻最热
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max marquee-track">
            {[...items, ...items].map((post, index) => (
              <Link
                key={`${post.id}-${index}`}
                to={`/post/${post.id}`}
                className="flex items-center gap-2 px-6 h-11 text-xs md:text-sm whitespace-nowrap hover:text-background-100 transition-colors cursor-pointer"
              >
                <span className="inline-flex items-center gap-1 text-foreground-950/70">
                  <i className="ri-fire-fill"></i>
                  {formatCount(post.heat)}
                </span>
                {post.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}